"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardChart = void 0;
const date_fns_1 = require("date-fns");
const helpers_1 = require("../../helpers");
const attributionMetrics_1 = require("../attributionMetrics");
const conversionMetrics_1 = require("../conversionMetrics");
const dashboardChart = (dateRange, conversionsIds, granularity = 'day', filters = [], conversionsNames = new Map(), disablePreaggregation = false) => ({
    mutexKey: `dashboardChart:dateRange:${dateRange[0]}:${dateRange[1]}:conversionsIds:${conversionsIds === null || conversionsIds === void 0 ? void 0 : conversionsIds.join(':')}:granularity${granularity}:filters${JSON.stringify(filters)}`,
    notPreaggregatedMeasures: [
        'Attribution.notPreaggregatedMeasure',
        ...(conversionsIds || []).map(() => 'Conversions.notPreaggregatedMeasure'),
    ],
    queries: [
        {
            measures: [
                'Attribution.cost',
                'Attribution.clicks',
                'Attribution.impressions',
                'Attribution.visitors',
                'Attribution.visits',
                ...(disablePreaggregation || new Date(dateRange[0]) < (0, date_fns_1.subDays)(new Date(), 92)
                    ? ['Attribution.notPreaggregatedMeasure']
                    : []),
            ],
            timeDimensions: [
                {
                    dimension: 'Attribution.date',
                    granularity: granularity,
                    dateRange,
                },
            ],
            filters: [
                ...(filters ? (0, helpers_1.filterFilters)(filters, 'Attribution.') : []),
                {
                    member: 'Attribution.date',
                    operator: 'inDateRange',
                    values: [dateRange[0], dateRange[1]],
                },
            ],
            limit: 10000,
        },
        ...(conversionsIds || []).map(conversionId => ({
            measures: [
                'Conversions.count',
                'Conversions.conversionValue',
                'Conversions.conversionCredit',
                ...(disablePreaggregation || new Date(dateRange[0]) < (0, date_fns_1.subDays)(new Date(), 92)
                    ? ['Conversions.notPreaggregatedMeasure']
                    : []),
            ],
            timeDimensions: [
                {
                    dimension: 'Attribution.date',
                    granularity: granularity,
                    dateRange,
                },
            ],
            filters: [
                ...(filters || []),
                {
                    member: 'Conversions.internalId',
                    operator: 'equals',
                    values: [conversionId],
                },
                {
                    member: 'Conversions.positiveConversionCredit',
                    operator: 'equals',
                    values: ['true'],
                },
            ],
            limit: 10000,
        })),
    ],
    resultProcessor: (rows) => {
        return {
            lastRefreshTime: new Date(Math.max(...rows.flatMap(row => row
                .serialize()
                .loadResponse.results.map(result => new Date(result.lastRefreshTime).valueOf())))),
            seriesNames: () => [
                ...Object.values(attributionMetrics_1.attributionMetrics).map(metric => ({
                    key: metric,
                    title: metric,
                    metric,
                    yValues: [metric],
                })),
                ...(conversionsIds || []).flatMap(conversionId => Object.values(conversionMetrics_1.conversionMetrics).map(metric => ({
                    key: `${conversionId}_${metric}`,
                    metric,
                    title: `${conversionsNames.get(conversionId) || conversionId} - ${metric}`,
                    yValues: [`${conversionId} - ${metric}`],
                }))),
            ],
            chartPivot: () => {
                const attributionPivot = rows[0].chartPivot();
                const conversionPivot = rows
                    .slice(1)
                    .map(row => new Map(row.chartPivot().map(value => [value.x, value])));
                return attributionPivot.map(value => {
                    const attribution = {
                        cost: Number(value['Attribution.cost'] || 0),
                        clicks: Number(value['Attribution.clicks'] || 0),
                        impressions: Number(value['Attribution.impressions'] || 0),
                        visitors: Number(value['Attribution.visitors'] || 0),
                        visits: Number(value['Attribution.visits'] || 0),
                    };
                    const calculatedAttributionMetrics = (0, attributionMetrics_1.calculateAttributionMetrics)(attribution);
                    const conversionInfos = rows.slice(1).map((_, i) => {
                        const conversionId = conversionsIds ? conversionsIds[i] : '';
                        const conversionsValue = conversionPivot[i].get(value.x) || {};
                        const conversionInfo = {
                            positiveConversionCreditCount: Number(conversionsValue['Conversions.count'] || 0),
                            conversionValue: Number(conversionsValue['Conversions.conversionValue'] || 0),
                            conversionCredit: Number(conversionsValue['Conversions.conversionCredit'] || 0),
                        };
                        return {
                            conversionId,
                            metrics: (0, conversionMetrics_1.calculateConversionMetrics)(attribution, conversionInfo),
                        };
                    });
                    return Object.assign(Object.assign({ x: value.x, xValues: value.xValues }, Object.keys(attributionMetrics_1.attributionMetrics).reduce((res, key) => {
                        res[attributionMetrics_1.attributionMetrics[key]] = calculatedAttributionMetrics[key];
                        return res;
                    }, {})), conversionInfos.reduce((res, conversionInfo) => {
                        const metrics = conversionInfo.metrics;
                        const prefix = conversionInfo.conversionId ? `${conversionInfo.conversionId}_` : '';
                        Object.keys(conversionMetrics_1.conversionMetrics).forEach((key) => {
                            res[`${prefix}${conversionMetrics_1.conversionMetrics[key]}`] = metrics[key];
                        });
                        return res;
                    }, {}));
                });
            },
        };
    },
});
exports.dashboardChart = dashboardChart;
//# sourceMappingURL=chart.js.map